module.exports = __webpack_public_path__ + "img/cloud-middle-right.5ac212b9.svg";